import React from "react";
import house6 from "../../../assets/house-6.jpg";

const ArrowRight = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path d="M1 7h12m-4-4 4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function HomeTop() {
  return (
    <>
      {/* ── Desktop hero ── */}
      <section style={{ padding: "64px 64px 0" }} className="pte-hero-desktop">
        <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 64, alignItems: "start" }}>
          {/* Left: copy */}
          <div style={{ paddingTop: 32 }}>
            <div className="chip" style={{ marginBottom: 28 }}>
              <span className="dot" /> Serving DC &amp; Maryland since 1992
            </div>
            <h1 style={{ fontSize: 88, lineHeight: 0.98, letterSpacing: "-0.02em", marginBottom: 28 }}>
              Settle in.<br />
              <span style={{ fontStyle: "italic", color: "var(--maroon-soft)" }}>We&rsquo;ll handle</span><br />
              the rest.
            </h1>
            <p style={{ fontSize: 19, lineHeight: 1.55, color: "var(--ink-soft)", maxWidth: 520, marginBottom: 36 }}>
              Friendlier, more personal title &amp; escrow services for buyers, sellers, agents and lenders
              across the District and Maryland — for over three decades.
            </p>
            <div style={{ display: "flex", gap: 12, marginBottom: 48 }}>
              <a href="https://preferredtitle.titlecapture.com/title-quote" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ padding: "16px 28px", fontSize: 15 }}>
                Request a free quote <ArrowRight />
              </a>
              <a href="https://ratecalculator.fnf.com/" target="_blank" rel="noopener noreferrer" className="btn btn-ghost" style={{ padding: "16px 28px", fontSize: 15 }}>
                Estimate title rate
              </a>
            </div>

            {/* Mini social proof */}
            <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
              <div style={{ display: "flex" }}>
                {["#a8826a", "#7a4a3a", "#c9a780", "#5a3a2a"].map((c, i) => (
                  <div key={i} style={{
                    width: 36, height: 36, borderRadius: "50%",
                    background: c, border: "2px solid var(--paper)",
                    marginLeft: i ? -10 : 0,
                  }} />
                ))}
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "var(--maroon)" }}>1,000+ closings, zero shortcuts</div>
                <div style={{ fontSize: 13, color: "var(--ink-soft)" }}>Trusted by realtors, lenders &amp; attorneys across MD &amp; DC</div>
              </div>
            </div>
          </div>

          {/* Right: image collage */}
          <div style={{ position: "relative", height: 580 }}>
            {/* Aerial photo */}
            <div style={{
              position: "absolute",
              top: 0, right: 0,
              width: 480, height: 520,
              borderRadius: 6,
              backgroundImage: `url(${house6})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              overflow: "hidden",
            }}>
              <div style={{
                position: "absolute",
                inset: 0,
                background: "linear-gradient(180deg, rgba(90,26,31,.1), rgba(90,26,31,.3))",
              }} />
              <div style={{
                position: "absolute",
                top: 24, right: 24,
                padding: "8px 14px",
                background: "var(--paper)",
                fontFamily: "var(--mono)",
                fontSize: 11,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                color: "var(--maroon)",
                borderRadius: 4,
              }}>
                Greenbelt, MD · Est. 1992
              </div>
            </div>

            {/* 1992 badge */}
            <div style={{
              position: "absolute",
              bottom: 60, left: 0,
              background: "var(--maroon)",
              color: "var(--cream)",
              padding: "28px 32px",
              borderRadius: 6,
              width: 260,
              boxShadow: "0 24px 48px -12px rgba(63,15,18,.35)",
            }}>
              <div style={{
                fontFamily: "var(--mono)",
                fontSize: 11,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                opacity: 0.7,
                marginBottom: 12,
              }}>
                Proudly serving since
              </div>
              <div style={{
                fontFamily: "var(--serif)",
                fontSize: 72,
                lineHeight: 1,
                fontWeight: 500,
                color: "var(--gold)",
              }}>
                1992
              </div>
              <div style={{ fontSize: 13, marginTop: 12, opacity: 0.85, lineHeight: 1.4 }}>
                D.C., Maryland &amp; the surrounding metro
              </div>
            </div>

          </div>
        </div>

        {/* Trust strip */}
        <TrustStrip />
      </section>

      {/* ── Mobile hero ── */}
      <section style={{ padding: "32px 20px 0" }} className="pte-hero-mobile">
        <div className="chip" style={{ marginBottom: 20, fontSize: 10 }}>
          <span className="dot" /> Serving DC &amp; MD since 1992
        </div>
        <h1 style={{ fontSize: 52, lineHeight: 0.96, letterSpacing: "-0.02em", marginBottom: 20 }}>
          Settle in.<br />
          <span style={{ fontStyle: "italic", color: "var(--maroon-soft)" }}>We&rsquo;ll handle</span><br />
          the rest.
        </h1>
        <p style={{ fontSize: 16, lineHeight: 1.5, color: "var(--ink-soft)", marginBottom: 24 }}>
          Friendlier, more personal title &amp; escrow services for buyers, sellers and agents across the District and Maryland.
        </p>

        {/* Hero image collage */}
        <div style={{ position: "relative", height: 360, marginBottom: 24 }}>
          <div style={{
            position: "absolute",
            top: 0, left: 0,
            width: 290, height: 320,
            borderRadius: 6,
            backgroundImage: `url(${house6})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }} />
          <div style={{
            position: "absolute",
            bottom: 0, right: 0,
            background: "var(--maroon)",
            color: "var(--cream)",
            padding: "20px 22px",
            borderRadius: 6,
            width: 180,
            boxShadow: "0 16px 32px -12px rgba(63,15,18,.4)",
          }}>
            <div style={{ fontFamily: "var(--mono)", fontSize: 9, letterSpacing: "0.15em", textTransform: "uppercase", opacity: 0.7, marginBottom: 6 }}>
              Serving since
            </div>
            <div style={{ fontFamily: "var(--serif)", fontSize: 52, lineHeight: 1, color: "var(--gold)" }}>1992</div>
            <div style={{ fontSize: 11, marginTop: 8, opacity: 0.85 }}>D.C. &amp; Maryland</div>
          </div>
        </div>

        <a href="https://preferredtitle.titlecapture.com/title-quote" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ width: "100%", padding: 16, fontSize: 15 }}>
          Request a free quote <ArrowRight />
        </a>
        <a
          href="https://ratecalculator.fnf.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-ghost"
          style={{ width: "100%", padding: 16, fontSize: 15, marginTop: 10 }}
        >
          Estimate title rate
        </a>

        {/* Mobile trust strip */}
        <div style={{ marginTop: 40 }}>
          <TrustStrip compact />
        </div>
      </section>

      <style>{`
        .pte-hero-desktop { display: block; }
        .pte-hero-mobile  { display: none; }
        @media (max-width: 768px) {
          .pte-hero-desktop { display: none; }
          .pte-hero-mobile  { display: block; }
        }
      `}</style>
    </>
  );
}

function TrustStrip({ compact = false }: { compact?: boolean }) {
  const items = [
    { num: "33+", label: "Years in business" },
    { num: "1,000+", label: "Customers served" },
    { num: "MD · DC", label: "Licensed regions" },
    { num: "Fidelity", label: "National Title underwriter" },
  ];
  return (
    <div style={{
      display: "grid",
      gridTemplateColumns: compact ? "1fr 1fr" : "repeat(4, 1fr)",
      gap: compact ? 24 : 0,
      borderTop: "1px solid var(--line)",
      borderBottom: "1px solid var(--line)",
      padding: compact ? "24px 0" : "32px 0",
      marginTop: compact ? 0 : 64,
    }}>
      {items.map((it, i) => (
        <div key={i} style={{
          padding: compact ? "0 16px" : "0 24px",
          borderRight: !compact && i < 3 ? "1px solid var(--line)" : "none",
        }}>
          <div style={{
            fontFamily: "var(--serif)",
            fontSize: compact ? 28 : 36,
            color: "var(--maroon)",
            fontWeight: 500,
            lineHeight: 1,
            marginBottom: 6,
          }}>
            {it.num}
          </div>
          <div style={{
            fontFamily: "var(--mono)",
            fontSize: 11,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            color: "var(--ink-soft)",
          }}>
            {it.label}
          </div>
        </div>
      ))}
    </div>
  );
}
